// Salik tax invoices: the shared invoice-generator core with the salik config (audit DUP-21 - invoiceKinds.js).
import React from 'react';
import KindInvoiceGenerator from './KindInvoiceGenerator';
import { INVOICE_KINDS } from './invoiceKinds';

export default function SalikGenerator() {
    return <KindInvoiceGenerator kind={INVOICE_KINDS.salik} />;
}
